import { __decorate, __metadata } from "tslib";
import { Component, ModelSync, Prop, Ref } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
import LvDropdown from "../dropdown/LvDropdown.vue";
import { Currency } from "@fastoche/ui-core/i18n/currency/Currency";
import { CURRENCY_DETAILS_LIST } from "@fastoche/ui-core/i18n/currency/CurrencyDetails";
import { LvButton } from "../button";
export const COMPONENT_NAME = "LvCurrencyPicker";
/**
 * A component to select a currency, from a list of defined currencies.
 */
let LvCurrencyPicker = class LvCurrencyPicker extends UIComponent {
    setCurrency(currency) {
        this.model = currency;
        this.dropdown.hide();
    }
    getSymbol(currency) {
        const symbol = CURRENCY_DETAILS_LIST[currency]?.nativeSymbol;
        if (symbol == currency)
            return;
        return symbol;
    }
};
__decorate([
    Prop({ type: Array, required: true }),
    __metadata("design:type", Array)
], LvCurrencyPicker.prototype, "currencies", void 0);
__decorate([
    ModelSync("value", "changed", { type: String, required: true }),
    __metadata("design:type", String)
], LvCurrencyPicker.prototype, "model", void 0);
__decorate([
    Ref(),
    __metadata("design:type", LvDropdown)
], LvCurrencyPicker.prototype, "dropdown", void 0);
LvCurrencyPicker = __decorate([
    Component({
        name: COMPONENT_NAME,
        components: { LvDropdown, LvButton },
    })
], LvCurrencyPicker);
export default LvCurrencyPicker;
//# sourceMappingURL=script.js.map